const DEFAULT_PREFIX = 'jsoncache_';
import { clearViceHomePage } from "@/lobby_common/api/cacheApi.js";

function getPrefixedKey(key) {
  const prefix = window.DB_KEY_PREFIX || DEFAULT_PREFIX;
  return `${prefix}${key}`;
}

// 初始化IndexedDB
function initUtilsIndexedDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("jsoncache", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("store")) {
        const store = db.createObjectStore("store", { keyPath: "id" });
      }
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      resolve(db);
    };

    request.onerror = (event) => {
      console.error("Error opening IndexedDB", event.target.error);
      reject(event.target.error);
    };
  });
}

// 保存数据到IndexDB 数据共享到ws
export function setDB(key, data) {
  const realKey = getPrefixedKey(key);
  initUtilsIndexedDB()
    .then((db) => {
      const transaction = db.transaction("store", "readwrite");
      const store = transaction.objectStore("store");
      store.put({ id: realKey, data: data });
    })
    .catch((error) => {
      console.error("Error saving to IndexedDB", error);
    });
}

// 删除指定 key 的数据
export function clearDB(key) {
  const realKey = getPrefixedKey(key);
  initUtilsIndexedDB()
    .then((db) => {
      const transaction = db.transaction("store", "readwrite");
      const store = transaction.objectStore("store");
      store.delete(realKey);
    })
    .catch((error) => {
      console.error("Error clearing data from IndexedDB", error);
    });
}

// 清空IndexDB数据
export async function clearAllDB() {
  try {
    const db = await initUtilsIndexedDB();
    const transaction = db.transaction("store", "readwrite");
    const store = transaction.objectStore("store");

    const clearRequest = store.clear();

    await new Promise((resolve, reject) => {
      clearRequest.onsuccess = () => resolve();
      clearRequest.onerror = () => reject(clearRequest.error);
    });

    // 清空副首页
    clearViceHomePage();

    console.log("✅ IndexedDB 数据已清空");
  } catch (error) {
    console.error("❌ 清空 IndexedDB 失败", error);
  }
}

// 从IndexDB中读数据
export function getDB(key) {
  const realKey = getPrefixedKey(key);
  return new Promise((resolve, reject) => {
    initUtilsIndexedDB()
      .then((db) => {
        const transaction = db.transaction("store", "readonly");
        const store = transaction.objectStore("store");

        const getRequest = store.get(realKey);
        getRequest.onsuccess = (event) => {
          const data = event.target.result;
          console.log("IndexedDB", data?.data);
          resolve(data?.data);
        };

        getRequest.onerror = (event) => {
          console.error(
            "Error getting data from IndexedDB",
            event.target.error
          );
          resolve(null);
        };
      })
      .catch((error) => {
        console.error("Error initializing IndexedDB", error);
        resolve(null);
      });
  });
}

export function objToQuery(obj) {
  return Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}